import React from 'react';
import { useParams } from 'react-router-dom';

import { menuListTeknisiKoordinator, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";

import BarangKategoriIndex from "../../pagesSub/msBarangKategori/BarangKategoriIndex";
import BarangFormCekIndex from "../../pagesSub/msBarangFormCek/BarangFormCekIndex";

const MasterTK = () => {

    const { subMenu } = useParams();
    const menu = menuListTeknisiKoordinator.master.slug;
    const roleUser = role.teknisi;
    // const slugLink = roleUser.subLevel.teknisi_kepala.slugLink;

    return (
        <LayoutAppShell
            stateMenuList={menuListTeknisiKoordinator}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListTeknisiKoordinator.master.subMenu.brgKtgr.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListTeknisiKoordinator}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangKategoriIndex />
                </React.Fragment>
            }

            {menuListTeknisiKoordinator.master.subMenu.formCekBrg.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListTeknisiKoordinator}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangFormCekIndex />
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default MasterTK;